var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input-number", {
        attrs: {
          min: _vm.minNum,
          max: _vm.maxNum,
          precision: _vm.precisionNum,
          step: Math.pow(10, _vm.precisionNum ? -_vm.precisionNum : 0),
        },
        model: {
          value: _vm.num,
          callback: function ($$v) {
            _vm.num = $$v
          },
          expression: "num",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "daxie" }, [
        _vm._v("大写：" + _vm._s(_vm.numFrom)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }